module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/compiled-file-7db77a6db4269983ccdcd9c5948f7d5a.svg";